import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-panels-wells',
  templateUrl: './panels-wells.component.html',
  styleUrls: ['./panels-wells.component.scss']
})
export class PanelsWellsComponent implements OnInit {
  @Input() heading: string;
  @Input() body: string;
  @Input() footer: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/panels-wells/panels-wells.component.ts